// @flow

import * as h2hApi from '../api/h2h';
import { API_CALL } from '../constants/actionTypes';
import { CREATE_CHALLENGE, H2H_CHALLENGE } from '../constants/apiTypes';
import selectionToPost from '../selectors/selectionToPost';

export function fetchSlate(slateId: string) {
  return {
    type: API_CALL,
    api: H2H_CHALLENGE,
    request: h2hApi.getSlate(slateId),
    id: slateId
  };
}

export function createChallenge(data: Object) {
  return (dispatch: Dispatch<*>, getState: GetState) => {
    const state = getState();
    const finalData = {
      ...data,
      selection: selectionToPost(state)
    };
    dispatch({
      type: API_CALL,
      api: CREATE_CHALLENGE,
      request: h2hApi.createChallenge(finalData)
    });
  };
}
